export const getMilitaryStatusesTranslateKeys = (militaryStatus: string): string => {
    switch (militaryStatus) {
        case 'executed': return 'MILITARY_STATUSES.EXECUTED';
        case 'not executed': return 'MILITARY_STATUSES.NOT_EXECUTED';
        case 'released': return 'MILITARY_STATUSES.RELEASED';
        default: return '';
    }
};
